let ctx = null;
let enabled = false;

const ensureCtx = () => {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === 'suspended') ctx.resume();
  return ctx;
};

const burst = ({ dur = 0.04, freq = 2000, q = 6, gain = 0.06, type = 'bandpass', when = 0 }) => {
  const c = ensureCtx();
  const t = c.currentTime + when;
  const buf = c.createBuffer(1, Math.max(1, Math.floor(c.sampleRate * dur)), c.sampleRate);
  const d = buf.getChannelData(0);
  for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / d.length);
  const src = c.createBufferSource();
  src.buffer = buf;
  const f = c.createBiquadFilter();
  f.type = type;
  f.frequency.value = freq;
  f.Q.value = q;
  const g = c.createGain();
  g.gain.setValueAtTime(gain, t);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  src.connect(f);
  f.connect(g);
  g.connect(c.destination);
  src.onended = () => { src.disconnect(); f.disconnect(); g.disconnect(); };
  src.start(t);
};

export const isEnabled = () => enabled;

/* Fire a harmless window event whenever a craft sound actually plays.
   Used for testability (audio can't be "heard" in automated tests). */
const notify = (name) => {
  try { window.dispatchEvent(new CustomEvent('pt-sfx', { detail: { name } })); } catch (e) { /* noop */ }
};

export const setEnabled = (v) => {
  enabled = v;
  try { localStorage.setItem('pt-sound', v ? '1' : '0'); } catch (e) { /* noop */ }
  if (v) ensureCtx();
};

export const initialEnabled = () => {
  try { return localStorage.getItem('pt-sound') === '1'; } catch (e) { return false; }
};

export const stitch = () => { if (enabled) burst({ dur: 0.03, freq: 2400 + Math.random() * 1400, q: 9, gain: 0.045 }); };

export const snap = () => {
  if (!enabled) return;
  burst({ dur: 0.035, freq: 1500, q: 7, gain: 0.08 });
  burst({ dur: 0.06, freq: 480, q: 4, gain: 0.06, when: 0.018 });
};

export const rustle = () => { if (enabled) { burst({ dur: 0.28, freq: 650, q: 0.7, gain: 0.03, type: 'lowpass' }); notify('rustle'); } };

export const zipper = () => {
  if (!enabled) return;
  for (let i = 0; i < 14; i++) burst({ dur: 0.018, freq: 850 + i * 130, q: 9, gain: 0.04, when: i * 0.02 });
};
